import React from "react";
import { Modal, Typography, Button, COLORS, Icon, Link } from "@virkesborsen/ui-component-library";
import { ContentContainer, GrowingContainer, IconContainer, StyledIcon } from "./utils/utils";

export const CarbonConfirmationStep = ({ currentStepIndex, totalSteps, handleBack, handleNext, handleClose,arbonicsData }) => {

  return (
    <>
      <Modal.Content>
        <ContentContainer >
          <GrowingContainer className="bg-neutral-stone-100 rounded-3 px-4 py-4 mt-2 text-center">
          <IconContainer>
            <StyledIcon name="checkOutlined" size="xxlarge" />
          </IconContainer>
            <Typography variant="subheaderSmallMedium">Din ansökan för {arbonicsData.selectedProp.designation.toLowerCase().replace(/^\w/, c => c.toUpperCase())} har skickats!</Typography>
            <Typography variant="bodySmallRegular">Vi kommer nu dela uppgifterna om din fastighet till våra samarbetspartners</Typography>
            <Typography variant="bodySmallRegular"> När analysen är klar kommer du att få en uppdatering från oss med en preliminär bedömning av intäktspotentialen samt en offert att ta ställning till.</Typography>
            <Typography variant="bodySmallRegular"> Du kommer även att få ett bekräftelsemail inom kort. Har du några frågor under tiden är du varmt välkommen att kontakta oss på <Link href="mailto:kolkrediter@treebula.se" > kolkrediter@treebula.se.</Link></Typography>
            <Typography variant="bodySmallRegular">Tack för din medverkan!</Typography>
          </GrowingContainer>
        </ContentContainer>
      </Modal.Content>
      <Modal.Footer>
        <Button
          fullWidth
          variant="primary"
          onClick={handleClose}
          label={"Stäng"}
          suffixIcon={"arrowRightSimple"}
        />
      </Modal.Footer>
    </>
  );
};

